export default __webpack_public_path__ + "static/media/card__image__bg--three.55e3da39.jpg";